import axios from 'axios';

// Fallback to a default URL if BASE_URL is not defined
const baseURL = process.env.BASE_URL || 'https://api.aicm.store';

const http = axios.create({
  baseURL: baseURL + '/api',  // Append '/api' to the baseURL
  timeout: 30000,
});
export const getProductBySlug = async (slug) => {
  const { data } = await http.get(`/products/${slug}`);
  return data;
};
// Fetch suggestions from the API
export const search = async (payload) => {
  const { data } = await http.post(`/search`, payload);
  return data;
};

export const getSearchFilters = async () => {
  const { data } = await http.get(`/search-filters`);
  return data;
};
